<app-pagetitle title="Objetivos" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="row">
  <div class="col-sm-12">
    <div class="card card-border">
      <div class="card-header">
        <div class="row" *hasDenied="{nivel:idSprNivel, app: constant.OBJETIVOS_ESTRATEGIAS}">
          <div class="col-sm-6 text-sm-right">
            <div *hasPermission="{app: constant.OBJETIVOS_ESTRATEGIAS, permission: [constant.CREAR]}">
              <ng-container *ngIf="valor==1;">
                <button type="button" class="btn btn-sm btn-success waves-effect"
                  (click)="openModalNew(formSelectAnio)"><i class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
              </ng-container>
              <ng-container *ngIf="valor==2;">
                <button type="button" *ngIf=" !verificarEstrategias(dataAtribucionObjMapeada)"
                  class="btn btn-sm btn-success waves-effect" (click)="openModalNew(formSelectAnio)"><i
                    class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>

                <button type="button" *ngIf="  verificarEstrategias(dataAtribucionObjMapeada)"
                  class="btn btn-sm btn-success waves-effect disabled-custom-btn" (click)="mostrarAlertaEstrategia()"><i
                    class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
              </ng-container>
            </div>
          </div>
        </div>

        <div class="d-flex flex-column align-items-end">
          <ng-template *hasDenied="{nivel:idSprNivel, app: constant.OBJETIVOS_ESTRATEGIAS}">
            <p><i class="fas fa-lock-open fa-lg text-success"></i></p>
          </ng-template>
          <ng-template #candado>
            <p><i class="fas fa-lock fa-lg text-danger"></i></p>
          </ng-template>
        </div>
      </div>
      <!-- Select años -->

      <!-- Fin Select años -->

      <div class="container card-body table-responsive ">
        <table datatable [dtOptions]="dtOptions " [dtTrigger]="dtTrigger "
          class="table table-striped table-bordered row-border hover ">
          <thead>
            <tr>
              <th colspan="3 "></th>
              <th colspan="4 " class="text-center ">Indicadores</th>
              <th colspan="4 "></th>
            </tr>
            <tr>
              <th>Nro</th>
              <th>Objetivos</th>
              <th>Nro. Estrategias</th>
              <th><i class="fa fa-square m-r-10 " style='color: red'></i></th>
              <th><i class="fa fa-circle m-r-10 " style='color: green'></i></th>
              <th><i class="fa fa-exclamation-triangle m-r-10 " style='color: orange'></i></th>
              <th><i class="fa fa-stop " style='color: blue'></i></th>
              <th *ngIf="idSprNivelN1 !=nivelSelect ">Atribuciones</th>
              <th *ngIf="idSprNivelN1 ==nivelSelect ">Competencias</th>
              <th *ngIf="valor==1;">Alineación a Estrategias del Nivel Superior</th>
              <th *ngIf="valor==2;">Estrategias</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            <!-- <tr *ngFor="let row of d; let indice=index "> -->
            <tr *ngFor="let row of dataAtribucionObjMapeada; let indice=index ">
              <td>{{indice+1}} </td>
              <td>{{row.nameAnio}} {{row.nombre}}</td>
              <td class="text-center ">{{row.nroEstrategias}}</td>
              <td class="text-center ">1</td>
              <td class="text-center ">1</td>
              <td class="text-center ">1</td>
              <td class="text-center ">1</td>
              <td class="text-center ">{{row.nroAtribuciones}}</td>
              <td class="text-center ">
                <button type="button " tooltip="Editar " class="btn btn-sm btn-link waves-effect rounded-pill "
                  title="Agregar estrategias " (click)="gestionObjetivosEstrategias(row)">
                  <i class="fas fa-tasks fa-lg "></i>
                </button>
              </td>
              <td class="text-center ">{{((row.estado == '1')? 'Activo': 'Inactivo')}}</td>

              <td class="text-center ">
                <div class="row" *hasDenied="{nivel:idSprNivel, app: constant.OBJETIVOS_ESTRATEGIAS}">
                  <button *hasPermission="{app: constant.OBJETIVOS_ESTRATEGIAS, permission: [constant.ACTUALIZAR]}"
                    type="button " tooltip="Editar " class="btn btn-sm btn-link waves-effect rounded-pill col px-0 "
                    title="Editar este registro " (click)="edit(row) ">
                    <i class="fas fa-pencil-alt fa-lg "></i>
                  </button>
                  <button *hasPermission="{app: constant.OBJETIVOS_ESTRATEGIAS, permission: [constant.BORRAR]}"
                    type="button " class="btn btn-sm btn-link waves-effect col px-0 " title="Eliminar este registro "
                    (click)="delete(row) ">
                    <i class="fas fa-trash-alt fa-lg "></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<jw-modal id="del" [isDelete]="true " (confirmation)="confirmDelete(dataAtribucionObjMapeada)"></jw-modal>

<jw-modal id="{{nameModal}}" #modalChild>
  <!-- MODAL PARA CREAR Y EDITAR -->
  <div class="modal-dialog modal-xl modal-dialog-scrollable" style="padding-top:8%">
    <div class="modal-content ">
      <div class="modal-header pb-3 ">
        <h3 class="modal-title ">{{nameAppModal}}</h3>
        <button type="button" class="btn-close" (click)="closeModal();" aria-label="Close"></button>
      </div>
      <div class="modal-body px-5 ">
        <form class="needs-validation" novalidate id="formObjetivo" [formGroup]="formObjetivo">

          <input type="hidden" id="idSprObjetivo" formControlName="idSprObjetivo">
          <!-- <input type="hidden" id="idSprAnioAnterior" formControlName="idSprAnioAnterior"> -->
          <div class="form-group row mb-2 pt-2">
            <div class="col col-md-2 text-md-right ">
              <label for="nombre"
                class=" form-control-label text-md-right pt-1 justify-content-end "><b>Unidad:</b></label>
            </div>
            <div class="col-12 col-md-10">
              <input type="text" maxlength="55" class="form-control" style="text-transform:uppercase;"
                readonly="readonly " required="true " value="{{nombreUnidad}}">
            </div>
          </div>
          <div class="form-group row mb-2">
            <div class="col col-md-2 text-md-right">
              <label for="idSprPlanAnio" class=" form-control-label text-md-right pt-1 "><b>Plan.-año:</b></label>
            </div>
            <div class="col-12 col-md-10">
              <input type="text" maxlength="55" class="form-control" style="text-transform: uppercase;"
                readonly="readonly " required="true" *ngFor="let row of dataPlanesInsPlanesAnios"
                [value]="row.nombre + ' || ' + row.anio">
              <div class="col text-danger">
              </div>
            </div>
          </div>
          <div class="form-group row mb-2 ">
            <div class="col col-md-2 text-md-right ">
              <label for="idSprObjetivo " class="col-form-label text-md-right "><b>Nombre:</b>
              </label>
            </div>
            <div class="col-12 col-md-10 ">
              <textarea id="idSprObjetivo" maxlength="500" type="text " class="form-control " required="true "
                formControlName="nombre"
                [ngClass]="{ 'is-invalid': this.formObjetivo.get( 'nombre')?.errors && this.submitted, 'is-valid': !this.formObjetivo.get('nombre')?.errors, } "
                style="height: 78px;">
                </textarea>
              <small class="invalid-feedback "
                *ngIf="this.formObjetivo.get('nombre')?.errors?.[ 'required'] && this.submitted ">Campo
                requerido</small>

            </div>
          </div>

          <div class="form-group row mb-2 ">
            <div class="col col-md-2 text-md-right ">
              <label for="idSprObjetivo " class="col-form-label text-md-right "><b>Descripción:</b>
              </label>
            </div>
            <div class="col-12 col-md-10 ">

              <textarea type="text" class="form-control" required="false" formControlName="descripcion" maxlength="3000 "
              [ngClass]="{'is-invalid':this.formObjetivo.get('descripcion')?.errors && this.submitted,'is-valid': this.formObjetivo.value.descripcion}"></textarea>
              <small class="invalid-feedback "
                *ngIf="this.formObjetivo.get( 'descripcion')?.errors?.[ 'required'] && this.submitted ">Campo
                requerido</small>

            </div>
          </div>

          <div class="form-group row mb-2 ">
            <div class=" col col-md-2 text-md-right ">
              <label for="fechaInicio " class=" form-control-label text-md-right pt-1 ">
                <b>Fecha inicio:</b></label>
            </div>
            <div class="col-12 col-md-4 ">
              <input type="date" class="form-control" required="true" placeholder="fecha Inicio"
                formControlName="fechaInicio" [ngClass]="{ 'is-invalid': this.formObjetivo.get( 'fechaInicio')?.errors && this.submitted, 'is-valid':
                        !this.formObjetivo.get( 'fechaInicio')?.errors,} " />
              <small class="invalid-feedback "
                *ngIf="this.formObjetivo.get( 'fechaInicio')?.errors?.[ 'required'] && this.submitted ">Campo
                requerido</small>
              <div class="col text-danger ">
                <span class="font-italic" *ngIf="this.formObjetivo.get( 'fechaInicio').errors?.fechaInicio ">La
                  fecha debe estar comprendida entre
                  {{this.formObjetivo.get('fechaInicio')?.errors.fechaInicio}}
                  y
                  {{this.formObjetivo.get('fechaInicio')?.errors.fechaFin}}
                </span>
              </div>

            </div>

            <div class=" col col-md-2 text-md-right ">
              <label for="fechaFin " class=" form-control-label text-md-right pt-1 "><b>Fecha
                  fin:</b></label>
            </div>
            <div class="col-12 col-md-4 ">
              <input type="date" class="form-control" required="true" placeholder="Fecha Fin" formControlName="fechaFin"
                [ngClass]="{ 'is-invalid': this.formObjetivo.get( 'fechaFin')?.errors && this.submitted, 'is-valid': !this.formObjetivo.get(
                        'fechaFin')?.errors, } " />
              <small class="invalid-feedback "
                *ngIf="this.formObjetivo.get( 'fechaFin')?.errors?.[ 'required'] && this.submitted ">Campo
                requerido</small>
              <div class="col text-danger ">
                <span class="font-italic " *ngIf="this.formObjetivo.get( 'fechaFin').errors?.fechaFin ">
                  La fecha debe estar comprendida entre
                  {{this.formObjetivo.get('fechaFin')?.errors.fechaInicio}}
                  y
                  {{this.formObjetivo.get('fechaFin')?.errors.fechaFin}}

                </span>
              </div>
            </div>
          </div>

          <div class="form-group row mb-2 ">

            <div *ngIf="idSprNivelN1==nivelSelect " class="col col-md-2 text-md-right ">
              <label for="idSprPerspectiva " class="col-form-label text-md-right "><b>Perspectiva:</b></label>
            </div>
            <div *ngIf="idSprNivelN1==nivelSelect " class="col-12 col-md-4 ">
              <select class="form-select " id="idSprPerspectiva" formControlName="idSprPerspectiva" required="true "
                [ngClass]="{ 'is-invalid': this.formObjetivo.get( 'idSprPerspectiva')?.errors && this.submitted, 'is-valid': this.formObjetivo.value.idSprPerspectiva} ">

                <option *ngFor="let catPerspectiva of dataCatEspecialPerspectiva "
                  value={{catPerspectiva.idSprEspecialUno}}>
                  {{catPerspectiva.nombre}} <!--(pond:
                                    {{catPerspectiva.ponderacion}}%) -->
                </option>
              </select>
              <div class="col text-danger ">
                <span class="font-italic "
                  *ngIf="this.formObjetivo.get( 'idSprPerspectiva')?.errors?.[ 'required'] && this.submitted ">Campo
                  requerido</span>
              </div>
            </div>

            <div *ngIf="idSprNivelN1 !=nivelSelect" class="col col-md-2 text-md-right">
              <label for="idSprEnfoque" class="col-form-label text-md-right "><b>Enfoque:</b></label>
            </div>
            <div *ngIf="idSprNivelN1 !=nivelSelect" class="col-12 col-md-4 ">
              <select class="form-select col-9" id="idSprEnfoque" formControlName="idSprEnfoque" required="true "
                [ngClass]="{ 'is-invalid': this.formObjetivo.get( 'idSprEnfoque')?.errors && this.submitted, 'is-valid': this.formObjetivo.value.idSprEnfoque} ">

                <option *ngFor="let catEnfoque of dataCatEspecialEnfoque" value={{catEnfoque.idSprEspecialUno}}>
                  {{catEnfoque.nombre}} <!--(pond:
                                    {{catEnfoque.ponderacion}}%) -->
                </option>
              </select>
              <div class="col text-danger ">
                <span class="font-italic "
                  *ngIf="this.formObjetivo.get( 'idSprEnfoque')?.errors?.[ 'required'] && this.submitted ">Campo
                  requerido</span>
              </div>
            </div>

            <div class="col col-md-2 text-md-right ">
              <label for="estado " class="col-form-label text-md-right "><b>Estado:</b></label>
            </div>
            <div class="col-12 col-md-4 ">
              <select id="estado" class="form-select" formControlName="estado" required="true"
                [ngClass]="{ 'is-invalid': this.formObjetivo.get('estado')?.errors && this.submitted, 'is-valid': !this.formObjetivo.get('estado')?.errors, } ">
                <option value="1" selected>Activo</option>
                <option value="2">Inactivo</option>
              </select>
              <div class="col text-danger ">
                <span class="font-italic "
                  *ngIf="this.formObjetivo.get( 'estado')?.errors?.[ 'required'] && this.submitted ">Campo
                  requerido</span>
              </div>
            </div>
          </div>

          <!--******Muestra en el formulario las atribuciones del ambiente actual******-->
          <div class="form-group row mb-2 ">
            <div class="col col-md-2 text-md-right ">
              <label for="nombre " class="col-form-label text-md-right "><b>Atribuciones:</b></label>
            </div>
            <div class="col-12 col-md-10 ">

              <table class="table table-striped table-bordered row-border hover" id="dataTable">
                <thead class="bg-azul text-white">

                </thead>
                <tbody>
                  <tr *ngFor="let row of listadoAtribuciones; let indice=index">
                    <td>
                      <input [checked]="row.checked" type="checkbox" class="form-check-input"
                        id="flexCheckDefault{{indice}}" (change)="onChange($event,row.idSprAtribucion)"
                        name="{{row.idSprAtribucion}} " value={{row.idSprAtribucion}}>
                      <a><label for={{row.idSprAtribucion}} class="form-check-label" >
                          {{row.nombre}}
                        </label></a>
                      <div class="col text-danger">
                        <span class="font-italic"
                          *ngIf="this.formObjetivo.get('nombre')?.errors?.[ 'required'] && this.submitted">Campo
                          requerido</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer ">
        <button type="button " class="btn btn-secondary waves-effect " (click)="closeModal(); ">Cerrar</button>
        <button type="button " class="btn btn-info " (click)="onSubmit() ">Guardar</button>
      </div>
    </div>
  </div>
</jw-modal>

<!-- ####################### ############################################ -->
<jw-modal id="{{nameModalGestion}}">
  <div class="modal-dialog modal-xl modal-dialog-scrollable " style="padding-top:5% ">
    <div class="modal-content ">
      <div class="modal-header pb-3 ">

        <button type="button " class="btn-close " (click)="closeModalEstrategias(); " aria-label="Close "></button>
      </div>

      <div class="modal-body px-5 ">
          <div class="card-header">
            <span><b>Objetivo Actual: </b>{{ objetivoNombre }}</span>
          </div>  

        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <ng-container *ngIf="valor==2;">
              <button (click)="getEstrategias() " class="nav-link active" id="estrategias-tab" data-bs-toggle="tab"
                data-bs-target="#estrategias" type="button" role="tab" aria-controls="estrategias"
                aria-selected="true ">Estrategia
              </button>
            </ng-container>
            <button *ngIf="idSprNivelN1 != nivelSelect" (click)="getEstrategiasSuperior() " class="nav-link"
              id="estrategiaSup-tab" data-bs-toggle="tab" data-bs-target="#estrategiaSup " type="button" role="tab"
              aria-controls="estrategiaSup" aria-selected="false ">Alineación a Estrategias del Nivel Superior</button>
          </div>
        </nav>

        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show active" id="estrategias" role="tabpanel " aria-labelledby="estrategias-tab ">
            <!-- ################## ESTRATEGIAS LINEALES ############################-->
            <app-objetivos-estrategias [msgEstrategia]="objetivo">
            </app-objetivos-estrategias>
            <!-- ############### // ESTRATEGIAS LINEALES ############################ -->
          </div>
          <div class="tab-pane fade" id="estrategiaSup" role="tabpanel" aria-labelledby="estrategiaSup-tab">
            <!-- ################  ESTRATEGIAS SUPERIOR ############################-->
            <app-objetivos-estrategias-superior [msgEstrategiaSup]="objetivo"></app-objetivos-estrategias-superior>
            <!-- ################ // ESTRATEGIAS SUPERIOR ###########################-->
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button " class="btn btn-secondary waves-effect" (click)="closeModalEstrategias(); ">Cerrar</button>
        <!--   <button type="button " class="btn btn-info " (click)="onSubmit() ">Guardar</button> -->
      </div>
    </div>
  </div>
</jw-modal>